import { LanguageSwitcher } from '../../components/app/LanguageSwitcher';
import { type ReactNode } from 'react';
import { Typography } from '@heroui/react';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { useRhinoAsset, useRhinoConfig } from '@rhino-project/core/config';
import { ThemedLogo } from '../../components/logos';

export interface AuthPageProps {
  children?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
}

const AuthPageBase = ({ children, title, description }: AuthPageProps) => {
  // authLogo overrides the auth-page logo with a single image; when unset it
  // falls back to the regular themed logo (darkLogo/lightLogo).
  const { authLogo, appName } = useRhinoConfig();
  const authLogoSrc = useRhinoAsset(authLogo);

  return (
    <div className="min-h-full flex flex-col items-center justify-center gap-3 p-4">
      <div className="bg-surface border border-separator rounded-2xl w-full max-w-sm p-8">
        <div className="flex justify-center mb-2">
          {authLogo ? (
            <img src={authLogoSrc} alt={appName} className="h-24" />
          ) : (
            <ThemedLogo className="h-24" />
          )}
        </div>
        {title && (
          <Typography.Heading level={3} className="mb-1">
            {title}
          </Typography.Heading>
        )}
        {description && (
          <p className="text-sm text-muted mb-6">{description}</p>
        )}
        {children}
      </div>
      <LanguageSwitcher variant="compact" />
    </div>
  );
};

export const AuthPage = (props: AuthPageProps) =>
  useGlobalComponentForModel('AuthPage', AuthPageBase, props);
